import { LeagueTeams } from '../../../../core/collections';

/**
 * @desc LeagueTeams
 * This Collection using for league teams
 */
export class CompsTeams extends LeagueTeams {
	get default_offset() {
		return 10;
	}

	setShowMyUrl() {
		this.url = 'comps/users';
		return this;
	}

	setRemoveTeamUrl() {
		this.url = 'comps/remove_user';
		return this;
	}

	setLeagueLadderUrl() {
		this.url = 'comps/ladder';
		return this;
	}

	showStreakLadder(data) {
		this.url = 'comps/gauntlet_ladder';
		return this.fetchData(data);
	}
}

export default CompsTeams;